import { createDatePickerComponents } from '../../../vendor/chakra-date-picker';
import { DateUI } from '../../../ui';
import { DatesUIImplConfig } from './uiDatesImplConfig';

export function createDatesUI(config: DatesUIImplConfig = {}): DateUI {
    return {
        DatePicker: createDatePickerComponents(),
    };
}
